// extracted by mini-css-extract-plugin
export default {"colorIcon":"_2Xzg6 CO6xt","emojiIcon":"BdMvi rTQr-","icon":"_2ztzj _2rmlO"};